<template>
	<div>
		<!--  -->
		<div class="input_list">
			<div class="input_one">
				<div style="display: flex;width:600px;">
					<div class="input_one_wen">操作人</div>
					<el-input size="small" v-model="form.name" type="text" style="width: 250px;" clearable=""
						placeholder="请输入操作人或手机号"></el-input>
				</div>
				<div class="input_one_wen">操作模块</div>
				<el-select v-model="form.modular" size="small" @change="getOplogList()" placeholder="全部模块"
					style="width: 200px">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-button type="primary" size="small" style="margin-left: 50px;" @click="getOplogList()">筛 选
				</el-button>
				<el-button type="text" size="small" style="margin-left: 10px;" @click="reload()">重置筛选条件</el-button>
			</div>
			<div class="input_one">
				<div style="display: flex;width:600px;">
					<div class="input_one_wen">操作时间</div>
					<el-date-picker style="width:250px;" size="small" v-model="form.Time" clearable="" type="daterange"
						placeholder="请选择日期" value-format="yyyy-MM-dd hh:mm:ss"
						@change="getOplogList()"></el-date-picker>
				</div>
				<!-- 				<div class="input_one_wen">操作类型</div>
				<el-select v-model="form.type" size="small" placeholder="全部" style="width: 200px">
					<el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select> -->
				<el-button @click="expor()" type="info" size="small" style="margin-left: 400px;">导出列表</el-button>
			</div>
		</div>
		<!--  -->
		<div class="usertable">
			<!-- <el-checkbox-group v-model="checkedlist"> -->
			<el-table :header-cell-style="{ background: '#F2F2F4','text-align':'center'}"
				:cell-style="{'text-align':'center'}" ref="multipleTable" :data="tableData" tooltip-effect="dark"
				style="width: 100%">
				<el-table-column prop="creattime" label="操作时间" width="250px"></el-table-column>
				<el-table-column prop="account" label="操作账号" width="200px"></el-table-column>
				<el-table-column prop="modular" label="操作模块" width="200px"></el-table-column>
				<!-- <el-table-column prop="type" label="操作类型 "></el-table-column> -->
				<!-- <el-table-column prop="oplogIp" label="操作人ID "width="150px"></el-table-column> -->
				<el-table-column prop="content" label="操作内容 "></el-table-column>
			</el-table>
			<!-- </el-checkbox-group> -->
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="page.page" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from '../../utils/index.js'
	export default {
		data() {
			return {
				url: url(),
				form: {
					name: "",
					type: "",
					modular: "",
					optStartTime: null,
					optEndTime: null,
					Time: null
				},
				// 操作模块列表
				options: [{
					label: '全部',
					value: ''
				}, {
					label: '发送券包',
					value: '发送券包'
				}, {
					label: '发型师调店',
					value: '发型师调店'
				}, {
					label: '免单核销券码',
					value: '免单核销券码'
				}, {
					label: '删除用户优惠券',
					value: '删除用户优惠券'
				}, {
					label: '发型师修改状态',
					value: '发型师修改状态'
				}, {
					label: '发型师修改订单服务',
					value: '发型师修改订单服务'
				}, {
					label: '绑定会员',
					value: '绑定会员'
				}, {
					label: '补充抖音审核订单',
					value: '补充抖音审核订单'
				}, {
					label: '加盟门店',
					value: '加盟门店'
				}, ],
				types: [{
					label: '全部',
					value: ''
				}, {
					label: '发送券包',
					value: '发送券包'
				}, {
					label: '免单核销券码',
					value: '免单核销券码'
				}, {
					label: '删除用户优惠券',
					value: '删除用户优惠券'
				}, {
					label: '发型师修改状态',
					value: '发型师修改状态'
				}, ],
				tableData: [],
				page: {
					page: 1,
					size: 10,
					total: 0,
				},
				query: ''
			};
		},
		methods: {
			handleSizeChange(val) {
				this.page.size = val;
				this.getOplogList();
			},
			handleCurrentChange(val) {
				this.page.page = val;
				this.getOplogList();
			},
			reload() {
				this.form = {
					name: "",
					type: "",
					modular: "",
					optStartTime: null,
					optEndTime: null,
				};
				this.getOplogList();
			},
			requestData() {
				this.query = "?page=" + this.page.page + "&size=" + this.page.size;
				if (this.form.name.trim().length > 0) this.query += "&operator=" + this.form.name
				if (this.form.modular.trim().length > 0) this.query += "&optModel=" + this.form.modular
				if (this.form.type.trim().length > 0) this.query += "&optType=" + this.form.type
				if (this.form.Time != null) {
					this.query += "&optStartTime=" + this.form.Time[0]
					this.query += "&optEndTime=" + this.form.Time[1]
				}
				// if (this.form.optStartTime != null) this.query += "&optStartTime=" + this.form.optStartTime
				// if (this.form.optEndTime != null) this.query += "&optEndTime=" + this.form.optEndTime
			},
			getOplogList() {
				this.requestData()
				this.$http.get('oplog/list' + this.query).then(res => {
					this.tableData = res.body.data;
					this.page.page = res.body.pageNum;
					this.page.size = res.body.pageSize;
					this.page.total = res.body.total;
				})
			},
			expor() {
				window.location.assign(this.url + "oplog/excel" + this.query)
			},
		},
		mounted() {
			this.getOplogList();
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .yxlabel {
		width: 20px;
		overflow: hidden;
	}

	.demotops {
		margin-bottom: 20px;
		width: 100%;
		height: 250px;
		background: #ECECEC;
		display: flex;
		padding: 30px;
		box-sizing: border-box;

		.demo1_card {
			width: 313px;
			height: 190px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.demo1_price {
			box-sizing: border-box;
			padding-top: 20px;
			margin-left: 40px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #444343;
			flex: 1;

			>div {
				&:nth-child(2) {
					margin-top: 15px;
				}
			}
		}

		.demo1_botton {
			margin-top: 80px;
		}

		// opacity: 0.51;
	}

	//输入框列表
	.input_list {
		.input_one {
			display: flex;

			&:nth-child(n + 2) {
				margin-top: 20px;
			}

			.input_one_wen {
				line-height: 30px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #3e3e3e;
				width: 150px;
			}
		}
	}

	// 页码器
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 表格
	.usertable {
		width: 100%;
		margin-top: 20px;

		.table_title {
			margin-bottom: 8px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #c9c9c9;
			width: 100%;
			text-align: right;
		}
	}

	.tablie_select {
		margin-top: 10px;
		display: flex;

		div {
			line-height: 30px;
		}
	}
</style>